export const truncateString = (string, limit) => {
  if (!string) {
    return '';
  }

  return string.substring(0, limit);
};

export const promiseLogWrapper = (promise, logger, actionName = 'Promise', domainName = 'Editor') => (args) => {
  logger.logTrace(`${actionName}Start|${domainName}`);
  return promise(args)
    .catch((err) => {
      logger.logError(`${actionName}Error|${domainName}`, err);
      throw err;
    })
    .finally(() => {
      logger.logTrace(`${actionName}End|${domainName}`);
    });
};

export const isStringEndWithEmoji = (string) => {
  const regex = /.*(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])$/;
  return regex.test(string);
};

export const truncateStringEndWithEmoji = (string, limit) => {
  if (!string) {
    return '';
  }

  if (string.length <= limit) {
    return string;
  }

  // 1 emoji = 2 chars
  if (isStringEndWithEmoji(string.substring(0, limit + 1))) {
    return string.substring(0, limit - 1);
  }

  return string.substring(0, limit);
};
